export default __webpack_public_path__ + "static/media/card_sahil.6e391e0e.png";